// extracted by mini-css-extract-plugin
module.exports = {"forwardHeader":"forwardHeader_forwardHeader__YZcMn","forwardText":"forwardHeader_forwardText__2th4M","forwordiconsec":"forwardHeader_forwordiconsec__1AM2B"};